import React from 'react';
import WeatherWidget from './widgets/WeatherWidget';
import LeaderboardWidget from './widgets/LeaderboardWidget';
import IssuesWidget from './widgets/IssuesWidget';
import PositiveWidget from './widgets/PositiveWidget';
import EventsWidget from './widgets/EventsWidget';
import EmbedWidget from './widgets/EmbedWidget';

const Sidebar = () => {
  return (
    <aside className="w-full space-y-0">
      <WeatherWidget />
      <LeaderboardWidget />
      <IssuesWidget />
      <PositiveWidget />
      <EmbedWidget />
      <EventsWidget />
    </aside>
  );
};

export default Sidebar;
